import { combineReducers } from '@reduxjs/toolkit'
import constants from './Constants'
import request from './Request'
import alerts from './Alerts'
import auth from './Auth'
import categories from './Categories'
import push from './Push'
import account from './Account'
import reseller from './Reseller'
import settings from './Settings'
import restaurants from './Restaurants'
import orders from './Orders'
import items from './Items'
import printers from './Printers'
import invoices from './Invoices'

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~ HELLO FELLOW DEVELOPER ~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 * Are you here to include yet another reducer on this list?
 * ....
 * ......
 * ........
 *
 * I guess you are.
 *
 * Thus, PL0X, don't forget to also include a `dispatch(clearXYZ())` call in Auth's slice.thunks.logout().
 * Otherwise, the current account's information will leak into the next account and Stranger Things™ will happen.
 */

const rootReducer = combineReducers({
	constants,
	request,
	alerts,

	auth,
	push,
	settings,
	account,
	reseller,
	restaurants,
	orders,
	items,
	categories,
	printers,
	invoices
})

export default rootReducer
